export default {
    data() {
        return {
            collectionList: [
                {
                    url: '#',
                    thumbnail: require(`@/assets/images/collection/collection-lg-01.jpg`),
                    smallThumbnails: [
                        {image: require(`@/assets/images/collection/collection-sm-01.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-02.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-03.jpg`)}
                    ],
                    client: require(`@/assets/images/client/client-15.png`),
                    title: 'Cubic Trad',
                    items: '27'
                },
                {
                    url: '#',
                    thumbnail: require(`@/assets/images/collection/collection-lg-02.jpg`),
                    smallThumbnails: [
                        {image: require(`@/assets/images/collection/collection-sm-04.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-05.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-06.jpg`)}
                    ],
                    client: require(`@/assets/images/client/client-12.png`),
                    title: 'Diamond Dog',
                    items: '20'
                },
                {
                    url: '#',
                    thumbnail: require(`@/assets/images/collection/collection-lg-03.jpg`),
                    smallThumbnails: [
                        {image: require(`@/assets/images/collection/collection-sm-07.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-08.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-09.jpg`)}
                    ],
                    client: require(`@/assets/images/client/client-13.png`),
                    title: 'Morgan11',
                    items: '15'
                },
                {
                    url: '#',
                    thumbnail: require(`@/assets/images/collection/collection-lg-05.jpg`),
                    smallThumbnails: [
                        {image: require(`@/assets/images/collection/collection-sm-10.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-11.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-12.jpg`)}
                    ],
                    client: require(`@/assets/images/client/client-14.png`),
                    title: 'Orthogon#720',
                    items: '10'
                },
                {
                    url: '#',
                    thumbnail: require(`@/assets/images/collection/collection-lg-02.jpg`),
                    smallThumbnails: [
                        {image: require(`@/assets/images/collection/collection-sm-01.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-02.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-03.jpg`)}
                    ],
                    client: require(`@/assets/images/client/client-15.png`),
                    title: 'Trad Mard',
                    items: '35'
                },
                {
                    url: '#',
                    thumbnail: require(`@/assets/images/collection/collection-lg-04.jpg`),
                    smallThumbnails: [
                        {image: require(`@/assets/images/collection/collection-sm-04.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-05.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-06.jpg`)}
                    ],
                    client: require(`@/assets/images/client/client-12.png`),
                    title: 'Dog Eligator',
                    items: '82'
                },
                {
                    url: '#',
                    thumbnail: require(`@/assets/images/collection/collection-lg-05.jpg`),
                    smallThumbnails: [
                        {image: require(`@/assets/images/collection/collection-sm-07.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-08.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-09.jpg`)}
                    ],
                    client: require(`@/assets/images/client/client-13.png`),
                    title: 'Monas ten',
                    items: '10'
                },
                {
                    url: '#',
                    thumbnail: require(`@/assets/images/collection/collection-lg-01.jpg`),
                    smallThumbnails: [
                        {image: require(`@/assets/images/collection/collection-sm-10.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-11.jpg`)},
                        {image: require(`@/assets/images/collection/collection-sm-12.jpg`)}
                    ],
                    client: require(`@/assets/images/client/client-14.png`),
                    title: 'Thememove',
                    items: '82'
                }
            ]
        }
    }
}